import { containsObject } from "../../../utils/helper";
import React, { useEffect } from "react";
import { useState } from "react";
import * as Notification from "../../../Notification";

const CardGift = ({
    url,
    item,
    amountSelected,
    maximumAvatar,
    selected,
    paint,
    handleSelectItem,
    giftSelected,
    handleChangePreview,
    t,
    subClass
}) => {
    const [checked, setChecked] = useState(false)
    const [itemIndex, setItemIndex] = useState(null)
    useEffect(() => {
        if (item && containsObject(item, giftSelected)) {
            setChecked(true)
        }else{
            setChecked(false)
        }
    }, [item, giftSelected])

    useEffect(()=>{
        const selectIndex = giftSelected.findIndex(i => i.id == item.id)
        setItemIndex(selectIndex || null)
    },[giftSelected])

    const handleCheckItem = (isChecked) => {
        if (isChecked == true && !containsObject(item, giftSelected)) {
            handleSelectItem([...giftSelected, item])
        }
        if (isChecked == false && containsObject(item, giftSelected)) {
            handleSelectItem(giftSelected.filter(i => i.id !== item.id))
        }
    }

    const handleOnClicked = () => {
        handleChangePreview(item)
    }
    const handleSelectedClicked = () => {
        if (containsObject(item, giftSelected)) {
            setChecked(!checked);
            handleCheckItem(!checked)
            return;
        }
        else if (maximumAvatar == amountSelected) {
            Notification.error(t("max_selected_gift"));
            return
        }
        setChecked(!checked)
        handleCheckItem(!checked)
    }

    return (
        <div
            className=" mr-[10px] lg:mb-[8px]"
            style={{
                borderRadius: "10px",
            }}>
            <div onClick={handleOnClicked} class={`block max-w-sm relative w-auto h-auto rounded-[10px] ${subClass} ${selected && 'm-[2px]'}`}>
                <img src={url} className={`rounded-[10px] ${paint ? "opacity-30" : ""}`} alt=""/>
                <span onClick={(e) => { e.stopPropagation(); handleSelectedClicked() }} className={`absolute z-[10] cursor-pointer top-3 left-1 w-[25px] h-[25px] rounded-full flex justify-center items-center leading-[12px] text-[13px] ${checked ? 'bg-black text-white' : 'bg-white border border-solid border-[#00000050]'}`}>
                    {checked ? itemIndex + 1 : ''}
                </span>
                {checked ? <span className={`w-full h-full absolute top-0 left-0 right-0 z-1 bg-[#ffffff70]`}></span> : ''}
            </div>
        </div>
    )
}

export default CardGift;